import styled, { css } from 'styled-components';
import { theme, toRem } from 'design';
import { CardRow } from '../Card';

interface IPageHeaderProps {
  appearance?: 'default' | 'transparent';
  hasStats?: boolean;
  dataCy?: string;
  hiddenMobile?: boolean;
}

const PADDING = `${toRem(theme.space['2xl'])} ${toRem(theme.space.xl)}`;
const PADDING_LARGE = `${toRem(theme.space['3xl'])} ${toRem(theme.space['3xl'])}`;

// The stats row pushes down by this and the header pulls up by the same amount, so both read it.
const STATS_OVERLAP = theme.card.minHeight.large / 2 + theme.space.xl;

const PageHeader = styled.header.attrs<IPageHeaderProps>((props) => ({ 'data-cy': props.dataCy || 'page-header', hiddenMobile: props.hiddenMobile }))<IPageHeaderProps>`
  position: relative;
  display: flex;
  flex-flow: column nowrap;
  justify-content: flex-start;
  align-items: flex-start;
  width: 100%;
  margin-bottom: ${toRem(theme.space.xl)};
  padding: ${PADDING};
  border-bottom: ${toRem(1)} solid ${theme.color.neutral[200]};
  background-color: ${theme.color.neutral[800]};
  gap: ${toRem(theme.space.sm)};

  @media (min-width: ${theme.breakpoint.small}px) {
    margin-bottom: ${toRem(theme.space['3xl'])};
    padding: ${PADDING_LARGE};
  }

  ${({ appearance }) =>
    appearance === 'transparent' &&
    css`
      background-color: transparent;
    `}

  ${({ hasStats }) =>
    hasStats &&
    css`
      margin-bottom: ${toRem(theme.space['3xl'])};
      padding-right: 0;
      padding-left: 0;
      padding-bottom: 0;
      border-bottom: none;

      @media (min-width: ${theme.breakpoint.small}px) {
        margin-bottom: ${toRem(-STATS_OVERLAP)};
        padding-right: 0;
        padding-bottom: 0;
        padding-left: 0;
        border-bottom: none;
      }

      > * {
        width: 100%;
        padding: 0 ${toRem(theme.space.xl)};

        @media (min-width: ${theme.breakpoint.small}px) {
          padding: 0 ${toRem(theme.space['3xl'])};
        }
      }
    `}


  ${CardRow} {
    margin-top: ${toRem(theme.space.xl)};
    margin-bottom: 0;
    padding-top: ${toRem(theme.space.xl)};
    border-top: ${toRem(1)} solid ${theme.color.neutral[200]};
    background-color: ${theme.color.white};

    @media (min-width: ${theme.breakpoint.small}px) {
      margin-top: ${toRem(STATS_OVERLAP)};
      padding-top: ${toRem(theme.card.minHeight.large / 2)};

      > div {
        top: ${toRem(-theme.card.minHeight.large)};
      }
    }
  }

  ${({ hiddenMobile }) =>
    hiddenMobile &&
    css`
      @media (max-width: ${theme.breakpoint.small}px) {
        display: none;
      }
    `}
`;

export default PageHeader;
